<template>
  <div class="sections-lateral-spaces">
    <div class="nv-grid">
      <div class="nv-grid-row">
        <div class="nv-grid-col nv-grid-col-12">
          <h1 class="special-style">
            {{ $t('about_us') }}
            <span class="mirror">
              {{ $t('about_us') }}
            </span>
          </h1>
        </div>
      </div>
  
      <div class="nv-grid-row">
        <div class="nv-grid-col nv-grid-col-12">
          <div class="nv-d-block nv-mt-4 nv-mb-2 nv-w-100 nv-w-md-70">
            <h2>
              {{ $t('mission_desc') }}
            </h2>
          </div>
        </div>
      </div>
  
      <div class="nv-grid-row">
        <div class="nv-grid-col nv-grid-col-12">
          <div class="nuinalp-hq-image nv-mt-8">
            <img
              src="/nuinalp_hq.svg"
              alt="Nuinalp HQ"
            >
          </div>
        </div>
      </div>
  
      <!-- Our history -->
      <div class="nv-grid-row nv-grid-multiline">
        <div class="nv-grid-col nv-grid-col-12">
          <h1 class="special-style">
            {{ $t('our_history') }}
            <span class="mirror">
              {{ $t('our_history') }}
            </span>
          </h1>
  
          <div class="nv-my-4 nv-w-100 nv-w-md-70">
            <h6>
              {{ $t('nnp_history_desc_1') }}
            </h6>
  
            <h6>
              {{ $t('nnp_history_desc_2') }}
            </h6>
          </div>
        </div>
        <div class="nv-grid-col nv-grid-col-12">
          <div class="nv-my-4 nv-w-100 nv-w-md-70">
            <h4>
              {{ $t('essence') }}
            </h4>
  
            <span class="nv-d-block nv-my-2">
              {{ $t('nnp_essence_desc_1') }}
            </span>
            <span class="nv-d-block nv-my-2">
              {{ $t('nnp_essence_desc_2') }}
            </span>
          </div>
        </div>
      </div>
  
      <!-- Milestones -->
      <div class="nv-grid-row nv-grid-multiline nv-position-relative">
        <!-- Lateral navigations -->
        <div class="lateral-button left nv-d-none nv-d-lg-flex" @click="backMilestone">
          <nv-icon>left</nv-icon>
        </div>
  
        <div class="lateral-button right nv-d-none nv-d-lg-flex" @click="nextMilestone">
          <nv-icon>right</nv-icon>
        </div>
  
        <div class="nv-grid-col nv-grid-col-12">
          <h1 class="special-style">
            {{ $t('milestones') }}
            <span class="mirror">
              {{ $t('milestones') }}
            </span>
          </h1>
        </div>
  
  
        <div class="nv-grid-col nv-grid-col-12">
          <div class="scroll-mask">
            <!-- Milestones -->
            <ul
              id="milestones-ul"
              class="nv-w-100 nv-d-flex nv-flex-column nv-flex-lg-row milestone-timeline"
            >
              <li
                v-for="(year, idx) in milestones"
                :key="idx"
                :class="{'active': selectedYear === year.year}"
                class="nv-mr-8 nv-pr-8"
              >
                <!-- Year -->
                <h1 class="nv-d-none nv-d-lg-flex">
                  {{ year.year }}
                </h1>
  
                <h3 class="nv-d-lg-none">
                  {{ year.year }}
                </h3>
  
                <!-- Moments -->
  
                <ul
                  class="nv-mb-3 nv-mt-8 nv-d-flex nv-flex-column nv-flex-lg-row
                  milestones-list nv-flex-nowrap"
                >
                  <li
                    v-for="(milestone, mIdx) in year.milestones"
                    :key="mIdx"
                    class="nv-mr-4 nv-mb-4"
                  >
                    <h5>
                      {{ milestone.title }}
                    </h5>
                    <p>
                      {{ milestone.description }}
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
  
      <!-- Our policy of quality -->
      <div class="nv-grid-row nv-grid-multiline">
        <div class="nv-grid-col nv-grid-col-12">
          <h1 class="special-style">
            {{ $t('our_policy_of_quality') }}
            <span class="mirror">
              {{ $t('our_policy_of_quality') }}
            </span>
          </h1>
        </div>
        <div class="nv-grid-col nv-grid-col-12">
          <div class="nv-my-4 nv-w-100 nv-w-md-70">
            <span class="nv-d-block nv-my-2">
              {{ $t('our_policy_of_quality_desc_1') }}
            </span>
            <span class="nv-d-block nv-my-2">
              {{ $t('our_policy_of_quality_desc_2') }}
            </span>
            <span class="nv-d-block nv-my-2">
              {{ $t('our_policy_of_quality_desc_3') }}
            </span>
            <span class="nv-d-block nv-my-2">
              {{ $t('our_policy_of_quality_desc_4') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>

// ---------------------------------------
// Hooks
// ---------------------------------------
const { t } = useI18n();

// -------------------------------------
// State
// -------------------------------------
const selectedYear = ref(2021);
const milestoneEl = ref<HTMLUListElement>();

// ---------------------------------------------
// Computed
// ---------------------------------------------
const milestones = computed(() => [
  {
    year: 2021,
    milestones: [
      {
        icon: undefined,
        title: t('introducing_nnp_vpn'),
        description: t('introducing_nnp_vpn_desc'),
        fullDate: '',
      },
      {
        icon: undefined,
        title: t('strategic_partnerships'),
        description: t('strategic_partnerships_desc'),
        fullDate: '',
      },
    ],
  },
  {
    year: 2020,
    milestones: [
      {
        icon: undefined,
        title: t('nnp_bron_as_ltda'),
        description: t('nnp_bron_as_ltda_desc'),
        fullDate: '',
      },
    ],
  },
  {
    year: 2019,
    milestones: [
      {
        icon: undefined,
        title: t('introducing_first_partner'),
        description: t('introducing_first_partner_desc'),
        fullDate: '',
      },
    ],
  },
  {
    year: 2016,
    milestones: [
      {
        icon: undefined,
        title: t('introducing_binarion'),
        description: t('introducing_binarion_desc'),
        fullDate: '',
      },
      {
        icon: undefined,
        title: t('vp_team_member'),
        description: t('vp_team_member_desc'),
        fullDate: '',
      },
    ],
  },
  {
    year: 2015,
    milestones: [
      {
        icon: undefined,
        title: t('nnp_was_born'),
        description: t('nnp_was_born_desc'),
        fullDate: '',
      },
    ],
  },
]);

// -------------------------------------
// Meta
// -------------------------------------

useHead(() => ({
  title: t('about_us_page_title') as string,
  meta: [{
    hid: 'description',
    name: 'description',
    content: t('mission_desc') as string,
  }],
}));

// -------------------------------------
// Methods
// -------------------------------------

function nextMilestone() {
  if (!milestoneEl.value) milestoneEl.value = document.querySelector('#milestones-ul') as HTMLUListElement;
  milestoneEl.value.scrollTo({
    top: 0,
    left: milestoneEl.value.scrollLeft + 580,
    behavior: 'smooth',
  });
}

function backMilestone() {
  if (!milestoneEl.value) milestoneEl.value = document.querySelector('#milestones-ul') as HTMLUListElement;

  milestoneEl.value.scrollTo({
    top: 0,
    left: milestoneEl.value.scrollLeft - 580,
    behavior: 'smooth',
  });
}

</script>
<style lang="scss" scoped>

@import '@nuiverse/core/src/style/utils/_variables';
@import '@nuiverse/core/src/style/_mixins';

h1,
h2,
h3,
h4,
h5,
h6 {
  &.special-style {
    display: inline-block;
    margin-bottom: $space-big;
    padding-bottom: 8px;
    position: relative;

    .mirror {
      font-size: 400%;
      left: 0;
      line-height: initial;
      opacity: 0.05;
      pointer-events: none;
      position: absolute;
      top: -40px;
      white-space: nowrap;
      width: 100%;
      z-index: 0;
    }

    &::before {
      background-color: var(--nv-theme-primary);
      bottom: 0;
      content: '';
      height: 2px;
      position: absolute;
      width: 40%;
    }
  }

}

.nuinalp-hq-image {
  background-color: var(--nv-theme);
  border-radius: 8px;
  display: block;
  height: 700px;
  overflow: hidden;
  width: 100%;

  img {
    margin-top: 100px;
    object-fit: cover;
    width: 100%;
  }
}

.partners-logo {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.partners-block {
  background-color: var(--nv-theme);
  border-radius: 8px;
  cursor: pointer;
  height: 200px;
  padding: 20px;
  width: 200px;

  img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
}

/*
* -------------------------------------------
* Milestones
* -------------------------------------------
*/

.milestone-timeline-nav {
  list-style: none;

  li {
    cursor: pointer;
    padding: 16px;

    &.active {
      border-bottom: 1px solid var(--nv-theme-primary);
    }
  }
}

.milestone-timeline {
  list-style: none;
  margin-bottom: -20px;
  overflow-x: scroll;
  padding: 20px;

  h1 {
    color: var(--nv-theme-primary);
    font-size: 100px;
    line-height: 100px;
  }

  h3 {
    color: var(--nv-theme-primary);
  }
}

.scroll-mask {
  overflow: hidden;
}

.milestones-list {
  list-style: none;

  li {
    width: 380px;
  }
}

/* Nav buttons */

.lateral-button {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100px;

  nv-icon {
    --font-size: 100px;
    color: var(--nv-type-secondary);
    line-height: normal;
    opacity: 0.2;
  }

  &:hover {
    nv-icon {
      opacity: 1;
    }
  }

  &.left {
    left: 0;
  }

  &.right {
    right: 0;
  }
}

@media screen and (max-width: 1023px) {
  .milestones-ul,
  .scroll-mask {
    overflow: unset;
  }

  .milestone-timeline {
    overflow: unset;
    padding: 0;
    padding-left: $space-md;
    position: relative;

    h3 {
      position: relative;

      &::before {
        background-color: #000;
        border-radius: 50%;
        content: '';
        height: 10px;
        left: -22px;
        position: absolute;
        top: 11px;
        width: 10px;
      }
    }

    &::before {
      background-color: #000;
      content: '';
      height: 96%;
      left: 6px;
      position: absolute;
      top: 14px;
      width: 1px;
    }

    li {
      margin-right: 0 !important;
      padding-right: 0 !important;
      width: 100%;

      ul {
        width: 100%;
      }
    }
  }
}

@include sm {
  h1 {
    .mirror {
      display: none;
    }
  }

  .nuinalp-hq-image {
    height: 200px;
  }

  .lateral-button {
    &.left {
      left: -20px;
    }

    &.right {
      right: -20px;
    }
  }
}

@include md {
  .nuinalp-hq-image {
    height: 300px;
  }

  .lateral-button {
    &.left {
      left: -50px;
    }

    &.right {
      right: -50px;
    }
  }
}

@include lg {
  .nuinalp-hq-image {
    height: 600px;
  }
}

@include xl {
  .nuinalp-hq-image {
    height: 768px;
  }

  .lateral-button {
    &.left {
      left: -100px;
    }

    &.right {
      right: -100px;
    }
  }
}
</style>
